import React from "react";
import { Modal, Button } from "antd";

const Popup = ({
  open,
  title,
  content,
  onCancel,
  onOk,
  width,
  footer = [
    <Button key="back" onClick={onCancel}>
      Cancel
    </Button>,
    <Button key="submit" type="primary" onClick={onOk}>
      OK
    </Button>,
  ],
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      centered
      footer={footer}
      width={width}
    >
      {content}
    </Modal>
  );
};

export default Popup;
